
import pcAddIshover from './module/pcAddIshover.js';
import pcViewportFixed from './module/pcViewportFixed.js';
import accessibleGnavToggle from './module/accessibleGnavToggle.js';
import smoothScroll from './module/smoothScroll.js';
import {fadeIn, fadeOut} from './module/fade.js';

(function () {
  window.addEventListener('DOMContentLoaded', function(e) {
    pcAddIshover();
    pcViewportFixed();
    smoothScroll();

    const btns = document.querySelectorAll('.js-fade-switch');
    const fadeoutbtns = document.querySelectorAll('.js-fadeout-switch');
    [].forEach.call(btns, function (btn) {
      btn.onclick = function(e) {
        const target = document.getElementById(e.currentTarget.getAttribute('href').replace('#', ''));
        fadeIn(target);
        document.querySelector('.c-modal__cont').scrollTo({top: 0});
      }
    });
    [].forEach.call(fadeoutbtns, function (btn) {
      btn.onclick = function(e) {
        const target = document.getElementById(e.currentTarget.value);
        fadeOut(target);
      }
    });
  });
  accessibleGnavToggle();
})();